<div class="container-fluid h-100">
 
  <div #datepicker class="row ml-2">
    <div class="row">
      <button class="col-auto q-btn q-main"
              (click)="OnSave()"
              [title]="idUser != '0' ? 'Affecter la liste des cycles Digital Learning au stagiaire' : idStage != '0' ? 'Affecter la liste des cycles Digital Learning à tous les apprenantsapprenants' : ''">
        <i class="fas fa-save"></i>
      </button>
    </div>

    <div class="col-auto q-c-main">Date expiration :</div>

    <div class="q-date" style=" width: 150px;">
      <!--<input type="date" name="dateExpiration" [ngModel]="dateExpiration | date:'yyyy-MM-dd'" (ngModelChange)="dateExpiration = $event; log($event)"/>-->
      <q-date name="dateExpiration" [ngValue]="dateExpiration" (ngValueChange)="dateExpiration = $event"></q-date>
    </div>

    <div *ngIf="displayModeAjoutUniquement" class="ml-2 q-check" title="Décocher cette case retire les cycles non cochés à tous les apprenants">
      <input type="checkbox" name="modeAjout" id="modeAjoutUniquement" [(ngModel)]="valueModeAjoutUniquement" />
      <label for="modeAjoutUniquement">
        <span></span>Uniquement en mode Ajout de cycle et date de fin aux apprenants (les anciens cycles restent affectés aux apprenants)
      </label>
    </div>

  </div>

  <div #listCheck class="container mt-3">

    <div class="row">
      <div *ngIf="idStage != '0'" class="col-4 mr-5 p-0">        
        <label class="q-c-main q-bold"
               title="ATTENTION : L'ensemble des apprenants du stage sélectionnés seront affectés par la mise en jour. Pour une affectation individuelle sélectionner stagiaire par stagiaire">
          <span></span>
          Liste des apprenants du stage
        </label>
      </div>

      <div class="col-auto p-0">        
        <label class="q-c-main q-bold"
               [title]="idUser != '0' ? '' : idStage != '0' ? 'ATTENTION : L\'ensemble des apprenants du stage sélectionnés seront affectés par la mise en jour. Pour une affectation individuelle sélectionner stagiaire par stagiaire' : ''">
          <span></span>
          {{idUser != '0' ? 'Liste des cycles Digital Learning affectés à l\'apprenant' : idStage != '0' ? 'Liste des cycles Digital Learning à affecter aux apprenants sélectionnés' : ''}}
        </label>
      </div>
    </div>


    <div class="row">
      <div *ngIf="idStage != '0'" class="q-check col-4 mr-5 p-0">
        <input type="checkbox" name="checkboxAllApprenants" id="checkboxAllApprenants" [ngModel]="CheckAllApprenantIsChecked()" (ngModelChange)="OnCheckAllApprenant()" />
        <label for="checkboxAllApprenants"
               class="q-bold"
               title="ATTENTION : L'ensemble des apprenants du stage sélectionnés seront affectés par la mise en jour. Pour une affectation individuelle sélectionner stagiaire par stagiaire">
          <span></span>
          Tout sélectionner
        </label>
      </div>

      <div class="q-check col-auto p-0">
        <input type="checkbox" name="checkboxAllCycles" id="checkboxAllCycles" [ngModel]="CheckAllIsChecked()" (ngModelChange)="OnCheckAll()" />
        <label for="checkboxAllCycles"
               class="q-bold"
               [title]="idUser != '0' ? '' : idStage != '0' ? 'ATTENTION : L\'ensemble des apprenants du stage sélectionnés seront affectés par la mise en jour. Pour une affectation individuelle sélectionner stagiaire par stagiaire' : ''">
          <span></span>
          Tout sélectionner
        </label>
      </div>
    </div>

  </div>



  <div class="container mt-2" [style.height]="sanitizer.bypassSecurityTrustStyle('calc(100% - ' + (datepicker.offsetHeight + listCheck.offsetHeight) + 'px - 1rem)')">

    <div class="row h-100">

      <div *ngIf="idStage != '0'" class="col-4 h-100 mr-5 pr-5" style="overflow:auto;" [style.height]="sanitizer.bypassSecurityTrustStyle('calc(100% - ' + (datepicker.offsetHeight + listCheck.offsetHeight) + 'px - 1rem)')">

        <ng-container *ngFor="let apprenant of apprenants; let i = index">
          <div class="row" [title]="apprenant.Tooltip">
            <div class="q-check">
              <input type="checkbox" name="checkboxApprenants" id="checkboxApprenants_{{i}}" [(ngModel)]="apprenant.Selected" />
              <label for="checkboxApprenants_{{i}}">
                <span></span>{{apprenant.Text}}
              </label>
            </div>
          </div>
        </ng-container>

      </div>

      <div class="col-auto h-100 pr-5" style="overflow:auto;" [style.height]="sanitizer.bypassSecurityTrustStyle('calc(100% - ' + (datepicker.offsetHeight + listCheck.offsetHeight) + 'px - 1rem)')">

          <ng-container *ngFor="let cycle of cyclesEl; let i = index">
            <div class="row" [title]="cycle.Tooltip">
              <div class="q-check">
                <input type="checkbox" name="checkboxCycles" id="checkboxCycles_{{i}}" [(ngModel)]="cycle.Selected" />
                <label for="checkboxCycles_{{i}}">
                  <span></span>{{cycle.Text}}
                </label>
              </div>
            </div>
          </ng-container>
        
      </div>

    </div>

  </div>
</div>
